import { connect } from 'react-redux';

import * as analytics from '@eb/site-analytics';

import { FIELD_NAMES } from './constants';

import {
    GA_SALES_STATUS_CATEGORY_CREATE_EDIT,
    GA_SALES_STATUS_CATEGORY_EVENT_STATUS,
    GA_SALES_STATUS_ACTION_POSTPONE_STARTED,
    GA_SALES_STATUS_BUTTON_DIMENSION,
    GA_SALES_STATUS_ACTION_CHANGE_STATUS_SUBMIT_OVERRIDE,
} from '@eb/event-create-analytics';
import { event, constants } from '@eb/event-create-publish-utils';

import {
    getFieldValue,
    getStatusOptions,
    initializeSalesStatusForm,
    hasSalesStatusFormChanged,
} from './utils';

import { resetCustomMessage } from './actions';
const {
    connectUtils: { getPostponeStartButtonNameDimension },
} = event;
const {
    DISPLAY_SALES_STATUS_ON_SALE,
    DISPLAY_SALES_STATUS_CUSTOM,
    DISPLAY_SALES_STATUS_NOT_YET_ON_SALE,
    DISPLAY_SALES_STATUS_NOT_YET_ON_SALE_ACCESS_CODED,
} = constants;

const { trackEventFromState } = analytics;

export const mapStateToProps = (state, { params: { eventId } = {} }) => {
    const {
        organizationFeatures: { customEventStatusEnabled } = {},
        eventSalesStatus: {
            isNotYetOnSale = false,
            changingSalesStatusIsBlocked = false,
            isOnSale = false,
            isNotYetOnSaleAccessCoded = false,
            salesStatusCode,
            salesStatusMessage,
            salesStartDate,
            salesStatusMessageType,
            salesStatusMessageCode,
        } = {},
    } = state;

    const statusOptions = getStatusOptions({
        customEventStatusEnabled,
        isOnSale,
        isNotYetOnSaleAccessCoded,
        isNotYetOnSale,
        salesStatusCode,
        salesStartDate,
        salesStatusMessageType,
        salesStatusMessageCode,
    });

    const selectedStatusCode = getFieldValue(state, FIELD_NAMES.statusCode);

    const isOnSaleSelected =
        selectedStatusCode === DISPLAY_SALES_STATUS_ON_SALE;
    const isNotYetOnSaleSelected =
        selectedStatusCode === DISPLAY_SALES_STATUS_NOT_YET_ON_SALE;
    const isNotYetOnSaleAccessCodedSelected =
        selectedStatusCode ===
        DISPLAY_SALES_STATUS_NOT_YET_ON_SALE_ACCESS_CODED;
    const isCustomSelected = selectedStatusCode === DISPLAY_SALES_STATUS_CUSTOM;

    // cases for taking tickets off sale:
    // 1- when the event status is on sale and you select any other option
    // 2- when the event status is not yet on sale or not yet on sale access coded and you select
    // another option except custom
    const willTakeOffSale =
        (isOnSale && !isOnSaleSelected) ||
        (((isNotYetOnSale && !isNotYetOnSaleSelected) ||
            (isNotYetOnSaleAccessCoded &&
                !isNotYetOnSaleAccessCodedSelected)) &&
            !isCustomSelected);

    const wontTakeOffSale =
        (isNotYetOnSaleAccessCoded || isNotYetOnSale) && isCustomSelected;

    return {
        salesStatusCode,
        salesStatusMessage,
        isCustomSelected,
        willTakeOffSale,
        wontTakeOffSale,
        changingSalesStatusIsBlocked,
        selectedStatusCode,
        statusOptions,
        hasSalesStatusFormChanged: hasSalesStatusFormChanged(
            selectedStatusCode,
            state,
        ),
        trackGASelectPostponeStatusEvent: () =>
            eventId
                ? trackEventFromState(
                      { gaSettings: state.gaSettings },
                      {
                          category: GA_SALES_STATUS_CATEGORY_EVENT_STATUS,
                          action: GA_SALES_STATUS_ACTION_POSTPONE_STARTED,
                          dimensions: {
                              eventId,
                              nameOfButton: getPostponeStartButtonNameDimension(
                                  GA_SALES_STATUS_BUTTON_DIMENSION,
                              ),
                          },
                      },
                  )
                : null,
        trackGAChangeSalesStatusEvent: () =>
            eventId
                ? trackEventFromState(
                      { gaSettings: state.gaSettings },
                      {
                          category: GA_SALES_STATUS_CATEGORY_CREATE_EDIT,
                          action: GA_SALES_STATUS_ACTION_CHANGE_STATUS_SUBMIT_OVERRIDE,
                          label: selectedStatusCode,
                          dimensions: {
                              eventId,
                          },
                      },
                  )
                : null,
    };
};

export const mapDispatchToProps = (dispatch) => ({
    onFormLoad: () => dispatch(initializeSalesStatusForm()),
    onStatusCodeChange: () => dispatch(resetCustomMessage()),
});

export default connect(mapStateToProps, mapDispatchToProps);
